// Template utilities shared between the landings list (template picker /
// "create from template" flow) and the landing editor ("create template
// from this event" flow).

export const extractVariables = (landing) => {
  const text = JSON.stringify({
    title: landing.title,
    subtitle: landing.subtitle,
    summary: landing.summary,
    ctaButton: landing.ctaButton,
    otherSections: landing.otherSections,
    additionalResources: landing.additionalResources,
  });
  const matches = text.match(/\{\{[^}]+\}\}/g) || [];
  return [...new Set(matches.map(m => m.slice(2, -2)))];
};

export const applyVariables = (obj, vars) => {
  const text = JSON.stringify(obj).replace(
    /\{\{([^}]+)\}\}/g,
    (_, key) => (vars[key] !== undefined ? vars[key] : `{{${key}}}`)
  );
  return JSON.parse(text);
};

export const labelFromVarName = (name) =>
  name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());

export const nameToSlug = (name) =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const sectionSlug = (title) =>
  title.toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .trim()
    .split(/\s+/)
    .filter(w => w.length >= 4)
    .slice(0, 3)
    .join('_');

export const tokenizeForTemplate = (landing) => ({
  ...landing,
  subtitle: '{{date}}',
  isTemplate: true,
  otherSections: landing.otherSections.map(section => ({
    ...section,
    content: section.content.replace(
      /https?:\/\/docs\.google\.com\/presentation\/[^\s)"']*/g,
      `{{${sectionSlug(section.title)}}}`
    ),
  })),
});
